/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, null, "Machine Learning and natural language processing for sentiment analysis"), "\n", React.createElement(_components.h2, null, "Used technologies"), "\n", React.createElement(_components.h3, null, "Python"), "\n", React.createElement(_components.h4, null, "Anaconda"), "\n", React.createElement(_components.h2, null, "How to get the news of our stocks?"), "\n", React.createElement(_components.h2, null, "Rapidapi to get the prices of the stocks"), "\n", React.createElement(_components.h2, null, "natural language processing"), "\n", React.createElement(_components.h2, null, "sentiment analysis"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
